import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
const CtaContent = t0 => {
  const $ = _c(38);
  const {
    children,
    className: t1,
    color: t2,
    hasArrow,
    hasBackArrow,
    hasUnderline: t3,
    isHovered,
    isLoading: t4,
    style: t5,
    styling
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const color = t2 === undefined ? "black" : t2;
  const hasUnderline = t3 === undefined ? false : t3;
  const isLoading = t4 === undefined ? false : t4;
  let t6;
  if ($[0] !== t5) {
    t6 = t5 === undefined ? {} : t5;
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const style = t6;
  const t7 = `capitalize ${className}`;
  const t8 = styling !== "link" && styling !== "link-underline";
  const t9 = styling === "link" || styling === "link-underline";
  const t10 = styling === "rainbow-button";
  const t11 = (styling === "link" || styling === "link-underline") && color === "white";
  const t12 = (styling === "link" || styling === "link-underline") && color === "black" && !isHovered;
  const t13 = (styling === "link" || styling === "link-underline") && color === "brand" || (styling === "link" || styling === "link-underline") && color === "black" && isHovered;
  const t14 = (styling === "link" || styling === "link-underline") && color === "black";
  let t15;
  if ($[2] !== color || $[3] !== styling) {
    t15 = (styling === "link" || styling === "link-underline") && ["brand", "brand-light"].includes(color);
    $[2] = color;
    $[3] = styling;
    $[4] = t15;
  } else {
    t15 = $[4];
  }
  let t16;
  if ($[5] !== color || $[6] !== styling) {
    t16 = styling === "solid-button" && ["black", "brand", "hotpink"].includes(color);
    $[5] = color;
    $[6] = styling;
    $[7] = t16;
  } else {
    t16 = $[7];
  }
  const t17 = styling === "link" && hasArrow;
  const t18 = styling === "link" && hasArrow && !isHovered;
  const t19 = styling === "link" && hasArrow && isHovered;
  const t20 = styling === "link" && hasBackArrow;
  const t21 = styling === "link" && hasBackArrow && !isHovered;
  const t22 = styling === "link" && hasBackArrow && isHovered;
  let t23;
  if ($[8] !== t10 || $[9] !== t11 || $[10] !== t12 || $[11] !== t13 || $[12] !== t14 || $[13] !== t15 || $[14] !== t16 || $[15] !== t17 || $[16] !== t18 || $[17] !== t19 || $[18] !== t20 || $[19] !== t21 || $[20] !== t22 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t23 = classNames(t7, {
      "flex items-center justify-center w-full": t8,
      inline: t9,
      "relative z-[2]": t10,
      "text-white hover:text-white group-hover/cta:text-white": t11,
      "text-gray-dark": t12,
      "text-brand": t13,
      "hover:text-brand group-hover/cta:text-brand": t14,
      "hover:text-gray-dark group-hover/cta:text-gray-dark": t15,
      "hover:text-white group-hover/cta:text-white": t16,
      "after:![content:'\u2192'] after:absolute after:top-1/2 after:-translate-y-1/2 after:transition-[margin] after:duration-100 after:ease-in-out group-hover/cta:after:ml-2": t17,
      "after:ml-[5px]": t18,
      "after:ml-2": t19,
      "pl-5 before:![content:'\u2190'] before:absolute before:top-1/2 before:-translate-y-1/2 before:transition-[margin] before:duration-100 before:ease-in-out group-hover/cta:before:-ml-6": t20,
      "before:-ml-5": t21,
      "before:-ml-6": t22
    });
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
    $[13] = t15;
    $[14] = t16;
    $[15] = t17;
    $[16] = t18;
    $[17] = t19;
    $[18] = t20;
    $[19] = t21;
    $[20] = t22;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t23;
  } else {
    t23 = $[24];
  }
  const t24 = hasUnderline || styling === "link-underline";
  let t25;
  if ($[25] !== isLoading || $[26] !== t24) {
    t25 = classNames("inline-flex items-center", {
      invisible: isLoading,
      "underline underline-offset-[3px]": t24
    });
    $[25] = isLoading;
    $[26] = t24;
    $[27] = t25;
  } else {
    t25 = $[27];
  }
  let t26;
  if ($[28] !== children || $[29] !== t25) {
    t26 = <span className={t25}>{children}</span>;
    $[28] = children;
    $[29] = t25;
    $[30] = t26;
  } else {
    t26 = $[30];
  }
  let t27;
  if ($[31] !== isLoading) {
    t27 = isLoading && <div className="absolute inset-0 flex flex-row"><ProgressLoaderDots /></div>;
    $[31] = isLoading;
    $[32] = t27;
  } else {
    t27 = $[32];
  }
  let t28;
  if ($[33] !== style || $[34] !== t23 || $[35] !== t26 || $[36] !== t27) {
    t28 = <span data-xc="Cta-content" className={t23} style={style}>{t26}{t27}</span>;
    $[33] = style;
    $[34] = t23;
    $[35] = t26;
    $[36] = t27;
    $[37] = t28;
  } else {
    t28 = $[37];
  }
  return t28;
};
CtaContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['brand', 'black', 'white', 'brand-light', 'hotpink']),
  hasArrow: PropTypes.bool,
  hasBackArrow: PropTypes.bool,
  hasUnderline: PropTypes.bool,
  isHovered: PropTypes.bool,
  isLoading: PropTypes.bool,
  style: PropTypes.object,
  styling: PropTypes.oneOf(['link', 'link-underline', 'outline-button', 'rainbow-button', 'simple-img-button', 'solid-button'])
};
export default CtaContent;